import { createFileRoute, notFound } from '@tanstack/react-router';
import { canUseMockMode } from '@/lib/mock-mode';
import { evalRunsQuery } from '@/services/content-evals';
import { DraftEvalsPage } from '@/features/admin/draft-evals/draft-evals-page';

// Dreamwell staff only: anyone else gets the not-found page (the API refuses them too).
export const Route = createFileRoute('/_authed/admin/draft-evals')({
  validateSearch: (search: Record<string, unknown>): { run?: string; case?: string } => ({
    ...(typeof search.run === 'string' && search.run ? { run: search.run } : {}),
    ...(typeof search.case === 'string' && search.case ? { case: search.case } : {}),
  }),
  beforeLoad: ({ context: { user } }) => {
    if (!canUseMockMode(user.email)) throw notFound();
  },
  loader: ({ context: { queryClient } }) => queryClient.ensureQueryData(evalRunsQuery()).catch(() => null),
  component: DraftEvalsPage,
});
